import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowMenu } from '../redux/controls';
import SideMenu from '../components/SideMenu/SideMenu';
import TopMenu from '../components/TopMenu/TopMenu';
import YouTubeContainer from '../components/YouTubeContainer/YouTubeContainer';
import Footer from '../components/Footer/Footer';
import '../styles/standardPageStyle.css';

export default function Utilization() {
  const { customer_util_videos } = useSelector((state) => state.controls);
  const dispatch = useDispatch();

  const toggleMenu = () => {
    dispatch(setShowMenu(false));
  };

  console.log('customer_util_videos on UTILIZATION PAGE', customer_util_videos);

  return (
    <div className="container-fluid stnd-container">
      <SideMenu />
      <TopMenu />
      <div className="stnd-header">
        <h1 className="stnd-h1 margin-left-two-percent">Utilization</h1>
      </div>
      <div className="row stnd-content" onClick={toggleMenu}>
        <div className="row stnd-top-content flex-start margin-bottom-thirty">
          {customer_util_videos &&
            customer_util_videos.map((video) => {
              return (
                <YouTubeContainer
                  key={video.id}
                  smallContainer={true}
                  embedId={video.video_link_id}
                  title={video.video_title}
                />
              );
            })}
        </div>

        <div className="row stnd-middle-content-flex-col"></div>

        <div className="row stnd-bottom-content"></div>
      </div>

      <Footer />
    </div>
  );
}
